module.exports = __webpack_public_path__ + "img/instagram_w.2625c821.svg";